module.exports = {["template-viewer-widget"]: function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='\n	<div class="rmwidget" data-id="'+
((__t=(id))==null?'':_.escape(__t))+
'"></div>\n';
}
return __p;
},}